import React from 'react';
import { cn } from '@/context/global/utils/cn'; // Assuming this utility is available

export type IconMusicFilterProps = {
  className?: string;
  size?: number;
};

export default function IconMusicFilter({
  className = '',
  size = 24,
}: IconMusicFilterProps) {
  return (
    <svg
      className={cn('text-white', className)}
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0957 3.14307H23.0481"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.0957 9.42871H11.5243"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.0957 15.7144H8.38142"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.0957 22H6.28618"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.403 23.0476C13.6643 23.0476 14.6868 22.0251 14.6868 20.7638C14.6868 19.5025 13.6643 18.48 12.403 18.48C11.1416 18.48 10.1191 19.5025 10.1191 20.7638C10.1191 22.0251 11.1416 23.0476 12.403 23.0476Z"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0475 19.2447V10.3295C23.0475 8.43331 21.8532 8.1714 20.6485 8.49617L16.0913 9.74283C15.2637 9.97331 14.6875 10.6228 14.6875 11.5762V13.1686V14.2372V20.7638"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7623 21.5285C22.0236 21.5285 23.0461 20.5061 23.0461 19.2447C23.0461 17.9834 22.0236 16.9609 20.7623 16.9609C19.501 16.9609 18.4785 17.9834 18.4785 19.2447C18.4785 20.5061 19.501 21.5285 20.7623 21.5285Z"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6875 14.2477L23.0475 11.9639"
        stroke="currentColor"
        strokeWidth="1.57143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
